export default '/build/b94efee7.png'